import { SelectWithLabel } from 'components/Form'
import * as React from 'react'
import { Draggable, Droppable } from 'react-beautiful-dnd'
import { I18n } from 'react-redux-i18n'
import { Collapse, Input } from 'reactstrap'
import EditFloat from '../EditFloat'
import { getStaticImage } from 'utils/statics'

import './styles.scss'
import { getChannelKey } from 'constants/channels'
import { lang } from 'utils/helpers'
const _ = require('lodash')

const fileSort = [
  {
    value: 'asc-name',
    label: 'dashboard_alphabetical-asc'
  },
  {
    value: 'desc-name',
    label: 'dashboard_alphabetical-desc'
  },
  {
    value: 'asc-date',
    label: 'dashboard_creation-date-asc'
  },
  {
    value: 'desc-date',
    label: 'dashboard_creation-date-desc'
  },
  {
    value: 'asc-users',
    label: 'dashboard_conversations-asc'
  },
  {
    value: 'desc-users',
    label: 'dashboard_conversations-desc'
  },
  {
    value: 'asc-operators',
    label: 'dashboard_operators-asc'
  },
  {
    value: 'desc-operators',
    label: 'dashboard_operators-desc'
  },
]

const BrandList = (props) => {
  const { brand: brandStore, delegations, openBrandModal, openDelegationModal, setSchedulesType, ...rest } = props

  const [ delegationsData, setDelegationsData ] = React.useState([])
  const [ brand, setBrand ] = React.useState({})
  const [filterOpen, setFilterOpen] = React.useState(false)
  const [searchOpen, setSearchOpen] = React.useState(false)
  const [sortSelect, setSortSelect] = React.useState('sort')
  const [searchParam, setSearchParam] = React.useState('')
  const filterOptions = fileSort.map((it) => ({ label: I18n.t(it.label), value: it.value }))

  React.useMemo(() => setBrand(brandStore), [brandStore])

  React.useEffect(()=> {
    setBrand({ ...brand, delegations: delegationsData })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delegationsData])

  React.useEffect(()=> {
    applyFilter(sortSelect)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortSelect])

  React.useEffect(()=> {
    applyFilter(sortSelect, searchParam)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam])

  const openFilter = () => {
    setSearchOpen(false)
    setFilterOpen(!filterOpen)
  }

  const openSearch = () => {
    setFilterOpen(false)
    setSearchOpen(!searchOpen)
  }

  const applyFilter = (value = sortSelect, _searchParam = searchParam) => {
    const data = _.clone(_searchParam ? delegations.filter(it => it.name.includes(_searchParam)) : delegations)
    switch (value) {
      case 'asc-name':
        setDelegationsData(data.sort((a, b) => a.name.localeCompare(b.name)))
        break
      case 'desc-name':
        setDelegationsData(data.sort((a, b) => a.name.localeCompare(b.name)*-1))
        break
      case 'asc-date':
        setDelegationsData(data.sort((a, b) => a.createdAt.localeCompare(b.createdAt)))
        break
      case 'desc-date':
        setDelegationsData(data.sort((a, b) => a.createdAt.localeCompare(b.createdAt)*-1))
        break
      case 'asc-users':
        setDelegationsData(data.sort((a, b) => validateNumber(a.totalUsers) - validateNumber(b.totalUsers)))
        break
      case 'desc-users':
        setDelegationsData(data.sort((a, b) => (validateNumber(a.totalUsers) - validateNumber(b.totalUsers))*-1))
        break
      case 'asc-operators':
        setDelegationsData(data.sort((a, b) => validateNumber(a.totalOperators) - validateNumber(b.totalOperators)))
        break
      case 'desc-operators':
        setDelegationsData(data.sort((a, b) => (validateNumber(a.totalOperators) - validateNumber(b.totalOperators))*-1))
        break
      default:
        setDelegationsData(data)
        break
    }
  }

  const validateNumber = (value) => {
    return Number.isInteger(value) ? value : 0
  }

  const image = (channel) => {
    let img = `${getStaticImage(`/channels/orange-brand/${channel}-icon.svg`)}`
    return <img src={img} alt={`${channel}`} />
  }

  return (
    <div>
      <div className='brand-container-inner'>
        {brand.isDefault ? <div className='default-center'>*</div> : null}
        <div className='brand-header'>
          <div className='section1'>
            <div className='title' {...rest}>
              <div className='options-panel'>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <i className='fa fa-comments'/>
                  <span>{brand.totalUsers}</span>
                  <i className='fa fa-user'/>
                  <span>{brand.totalOperators}</span>
                </div>
                <div className='options'>
                  <i className={`fa fa-filter ${filterOpen ? 'open-icon' : ''}`} onClick={openFilter} />
                  <i className={`fa fa-search ${searchOpen ? 'open-icon' : ''}`} onClick={openSearch} />
                  <EditFloat
                    isBusinessSchedule
                    isEdit
                    isRemove={!brand.isDefault}
                    businessScheduleAction={(tag) => setSchedulesType({ group: 'brand', createdTo: brand._id, tag })}
                    editAction={() => openBrandModal(brand)}
                    removeAction={() => openBrandModal({ ...brand, forRemove: true })}
                  />
                </div>
              </div>
              <div className='brand-name-container'>
                <div className='brand-label'>
                  <strong>{lang('dashboard_brand')}</strong>
                </div>
                <p className='brand-name'>
                  {brand.name}
                </p>
              </div>
            </div>
          </div>

          <div className='filters'>
            <Collapse isOpen={filterOpen}>
              <div className='filter-container'>
                <SelectWithLabel
                  name='sort'
                  key='sort'
                  classNameWrapper='select-organization'
                  placeholder={I18n.t('dashboard_selector_order-by')}
                  options={filterOptions}
                  value={filterOptions.find(element => element.value === sortSelect) || ''}
                  onChange={item => {
                    if (item) {
                      setSortSelect(item.value)
                    } else {
                      setSortSelect('')
                    }
                  }}
                  isClearable
                />
              </div>
            </Collapse>
            <Collapse isOpen={searchOpen}>
              <div className='filter-container'>
                <Input
                  className='new-input'
                  value={searchParam}
                  onChange={({ target: { value } }) => setSearchParam(value)}
                />
              </div>
            </Collapse>
          </div>

        </div>

        <Droppable  droppableId={`${brand._id}`} type='DELEGATIONS'>
          {(provided_cd, snapshot) => (
            <div
              ref={provided_cd.innerRef}
              {...provided_cd.droppableProps}
              className='brand-body'
              style={{
                minHeight: snapshot.isDraggingOver ? 170 : 75
              }}
            >
              {
                brand.delegations && brand.delegations.map((it, idx) => (
                  <Draggable
                    key={it._id}
                    draggableId={it._id}
                    index={idx}
                    isDragDisabled={it.isDefault}
                  >
                    {provided_d => (
                      <div
                        id={`brand-${it._id}`}
                        ref={provided_d.innerRef}
                        {...provided_d.draggableProps}
                        className='delegation-container'
                        style = {{
                          ...provided_d.draggableProps.style
                        }}
                        {...provided_d.dragHandleProps}
                      >
                        {it.isDefault ? <div className='default-center'>*</div> : null}
                        <div key={idx} className=''>
                          <div className='options-panel'>
                            <div className='show-comments'>
                              <i className='fa fa-comments options-on-on'/>
                              <span className='options-on'>{it.totalUsers}</span>
                              <i className='fa fa-user options-on'/>
                              <span className='options-on'>{it.totalOperators}</span>
                            </div>
                            <EditFloat
                              isBusinessSchedule
                              isEdit
                              isRemove={!it.isDefault}
                              businessScheduleAction={(tag) => setSchedulesType({ group: 'delegation', createdTo: it._id, tag })}
                              editAction={() => props.openDelegationModal(it)}
                              removeAction={() => props.openDelegationModal({ ...it, forRemove: true })}
                            />
                          </div>
                          <h3 className='title-delegation' {...provided_d.dragHandleProps}>
                            {it.name}
                          </h3>
                          <div className='channels-list'>
                            {it.channels.map((channel, index) => (
                              <figure key={index} title={channel.value?.name || channel.value?.botId || ''}>
                                {image(getChannelKey(channel.key))}
                              </figure>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))
              }
              {!snapshot.isDraggingOver && (
                <div
                  className='brand-footer'
                  onClick={() => props.openDelegationModal(null, brand)}
                >
                  {I18n.t('dashboard_add-delegation')}
                </div>
              )}
              {provided_cd.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </div>
  )
}

export default BrandList
